import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=2bd4a6ec&scoped=true&"
import script from "./Interview.vue?vue&type=script&lang=js&"
export * from "./Interview.vue?vue&type=script&lang=js&"
import style0 from "./Interview.vue?vue&type=style&index=0&id=2bd4a6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4a6ec",
  null
  
)

export default component.exports